export default __webpack_public_path__ + "static/media/recruiter-stats-funnel.b3c2d38c.svg";